import UpsellModal from "./upsell-modal";

export default UpsellModal;
export type { UpsellModalProps } from "./types";
